import React, { useState,useRef,useEffect } from 'react';

import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';

import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioHttp from '../../servicio/ServicioHttp';


export const ModalEditarEmpresa = (props) => {

    const {empresaEditar, mostrarModal,funcionCerrarModal} =props;
    const [errores,setErrores]=useState({});
    const [empresa,setEmpresa]=useState({});
    let growl = useRef(null);

    useEffect(() => {
        let laEmpresa={ ...empresaEditar };
        setErrores({});
        setEmpresa(laEmpresa);
    }, [empresaEditar]);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setEmpresa(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const guardar = () => {
        const validacion = validarFormulario();
        setErrores(validacion);
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let empresaEnvio = {};
            empresaEnvio.id = empresa.id;            
            empresaEnvio.rfc = empresa.rfc;
            empresaEnvio.registroPatronal = empresa.registroPatronal;
            empresaEnvio.razonSocial = empresa.razonSocial;
            empresaEnvio.representanteLegal = empresa.representanteLegal;
            empresaEnvio.actividadEconomica = empresa.actividadEconomica;
            empresaEnvio.nombreCortoRazonSocial = empresa.nombreCortoRazonSocial;
            servicioHttp.consumirPostHttp("empresa/editar.json", empresaEnvio).then(response => {
                growl.current.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (!response.data.error) {
                    cerrarModal();
                }
            }).catch(error => {
                growl.current.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }


    const validarFormulario = () => {
        const errores = {};
        var expreReg = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/;
        var validacionRFC = expreReg.exec(empresa.rfc);

        if (!validacionRFC)
            errores.rfc = "Ingrese RFC";
        if (servicioObjetos.esObjetoVacio(empresa.registroPatronal))
            errores.registroPatronal = "Ingrese Registro Patronal";

        if (servicioObjetos.esObjetoVacio(empresa.razonSocial))
            errores.razonSocial = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.representanteLegal))
            errores.representanteLegal = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.actividadEconomica))
            errores.actividadEconomica = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.nombreCortoRazonSocial))
            errores.nombreCortoRazonSocial = "Campo requerido";               
        return errores;
    }

    const cerrarModal = () => {
        funcionCerrarModal(false);
    }

    const pieDialogo = <div className="ui-dialog-buttonpane p-clearfix">

        <Button
            label="Guardar"
            icon="pi-md-save"
            onClick={guardar} />
        <Button
            label="Cancelar"
            icon="pi-md-close"
            onClick={cerrarModal}
            className="p-button-danger " />
    </div>;

    return (
        <div>
            <Growl ref={growl} />
            <Dialog
                visible={mostrarModal}
                style={{ width: '80%' }}
                appendTo={document.body}
                header="Administración de patrones"
                modal={true} footer={pieDialogo}
                onHide={cerrarModal}>
                <div className="card">
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos de la Empresa</h4>
                    <div className="p-grid form-group">
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="11" id="registroPatronal"
                                    name="registroPatronal" value={empresa.registroPatronal || ""}
                                    className={errores.registroPatronal ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)}
                                    style={{ width: "90%" }} />
                                <label>* Registro Patronal:</label>
                                {errores.registroPatronal ? <div><Message severity="error"
                                    text={errores.registroPatronal} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="razonSocial"
                                    name="razonSocial" value={empresa.razonSocial || ""}
                                    className={errores.razonSocial ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Razón Social:</label>
                                {errores.razonSocial ? <div><Message severity="error"
                                    text={errores.razonSocial} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="100" id="nombreCortoRazonSocial"
                                    name="nombreCortoRazonSocial"
                                    value={empresa.nombreCortoRazonSocial || ""}
                                    className={errores.nombreCortoRazonSocial ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Nombre corto razón Social:</label>
                                {errores.nombreCortoRazonSocial ? <div><Message severity="error"
                                    text={errores.nombreCortoRazonSocial} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="13" id="rfc"
                                    name="rfc" value={empresa.rfc || ""}
                                    className={errores.rfc ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Rfc Empresa:</label>
                                {errores.rfc ? <div><Message severity="error" text={errores.rfc} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="representanteLegal"
                                    name="representanteLegal" value={empresa.representanteLegal || ""}
                                    className={errores.representanteLegal ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Representante Legal:</label>
                                {errores.representanteLegal ? <div><Message severity="error"
                                    text={errores.representanteLegal} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="actividadEconomica"
                                    name="actividadEconomica" value={empresa.actividadEconomica || ""}
                                    className={errores.actividadEconomica ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Actividad Economica:</label>
                                {errores.actividadEconomica ? <div><Message severity="error"
                                    text={errores.actividadEconomica} /> </div> : null}
                            </span>
                        </div>                       
                    </div>
                </div>
            </Dialog>
        </div>
    );
}